export enum CreativeTemplatesEntities {
  IMAGES = 'images',
  VIDEOS = 'videos',
  PostTexts = 'postTexts',
  Headlines = 'headlines',
  Descriptions = 'descriptions',
  CTAs = 'ctas'
}
